module.exports = "<div seedelement><slot></slot></div>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-tabbar/theme/lui-tabbar.html
// module id = 340
// module chunks = 0 1 6